webpackJsonp(["pages.help.show"],{

/***/ "./help/help.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {// We will render the icons list here
/* harmony default export */ __webpack_exports__["a"] = (function () {
  if ($('#user-content-gitlab-icons').length > 0) {
    var $iconsHeader = $('#user-content-gitlab-icons');
    var $iconsList = $('<div id="iconsList">ICONS</div>');
    $($iconsList).insertAfter($iconsHeader.parent());
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/help/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__help_help__ = __webpack_require__("./help/help.js");


document.addEventListener('DOMContentLoaded', __WEBPACK_IMPORTED_MODULE_0__help_help__["a" /* default */]);

/***/ })

},["./pages/help/show/index.js"]);


// WEBPACK FOOTER //
// pages.help.show.9af44bad6a6aa7d26256.bundle.js